angular.module('jv.candidate.details.evaluations.controller', [])
    .controller('CandEval', ['$scope', '$routeParams', 'candidates', '$location', '$rootScope', 'evalSvc', '$log',
        function($scope, $routeParams, candidates, $location, $rootScope, evalSvc, $log){
            var modalType;
            var modalState;
            $scope.modal = $rootScope.modal || {};
            $rootScope.miniHeader = {
                show: false
            };
            $scope.showSummary = false;
            $scope.toggleSummary = function() {
                $scope.showSummary = !$scope.showSummary;
            };
            $scope.allFormsHidden = function() {
            if (
                !$scope.evaluations ||
                !$scope.evaluations.interviewList_map ||
                !$scope.evaluations.interviewList_map.list
            ) {
                return true;
            }
            return $scope.evaluations.interviewList_map.list.every(function(state) {
                return $scope.empty(state.list);
            });
            };
            $rootScope.$emit('getEvaluationsCount');
            if(!$rootScope.evaluations || ($rootScope.evaluations && !$rootScope.evaluations.grades)){
                $rootScope.evaluations = {
                    grades:[
                        $scope.i18n.EXCELLENT,
                        $scope.i18n.GOOD,
                        $scope.i18n.FAIR,
                        $scope.i18n.POOR,
                        $scope.i18n.NA
                    ]
                };
            }

            $scope.flags.loading = false;
            if($scope.perms.INTERVIEW_EVALUATIONS_GET) {
                $scope.addLoading('evalDetails');
                candidates.getAllEvaluations($routeParams.applicationId, $rootScope.evaluations.fastRead || $rootScope.evaluations.justSubmitted, function(res){
                    $rootScope.evaluations.interviewList = res.evaluationInfo;
                    $rootScope.evaluations.loggedInuser = window.jvUser;
                    $rootScope.evaluations.interviewList_map = evalSvc.transformInterviewEvaluations($rootScope.evaluations.interviewList);
                    $scope.removeLoading('evalDetails');
                }, function(err){
                    $log.error(err);
                });
            }

            if($rootScope.evaluations.fastRead){
                $rootScope.evaluations.fastRead = false;
            }

            $scope.hasCompletedEvals = function(list){
                var copyList = angular.copy(list);
                delete copyList._PENDING;
                return !$scope.empty(copyList);
            };

            $scope.modal.cancel = function(){
                $rootScope.modal.form.to = null;
                $rootScope.modal.show = false;
            };

            $scope.modal.ok = function() {
                var data = angular.copy($rootScope.modal.form);
                var toList = [];
                if (data.to && angular.isArray(data.to)){
                    angular.forEach(data.to, function(value){
                        toList.push({eid: value.EId});
                    });
                }else if(data.to_label){
                    angular.forEach(data.toObj, function(value){
                        toList.push({eid: value.EId});
                    });
                }
                data.to = toList;
                if(data.to.length === 0){
                    return;
                }
                angular.forEach(data.cc, function(cc){
                    data.to.push({eid: cc.EId});
                });
                delete data.cc;
                delete data.toObj;
                delete data.to_label;
                delete data.hideCC;
                data.from = { eid: window.jvUser };

                $rootScope.flags.loading = true;
                if(modalType === 'SEND_REMINDER'){
                    candidates.postEvaluationReminder($routeParams.applicationId, modalState.interviewState, data, function(res){
                        if(res.msgInfo === 200){
                            $scope.showMsg('REMINDER_SENT');
                            $rootScope.modal.form.to = null;
                            $rootScope.flags.loading = false;
                            $rootScope.modal.show = false;
                        }
                    }, function(err){
                        $log.error(err);
                    });
                }else if(modalType === 'FORWARD'){
                    candidates.postEvalForwardTmpl($routeParams.applicationId, data, function(res){
                        $rootScope.flags.loading = false;
                        if(res.msgInfo === 200){
                            $scope.showMsg('EVALUATION_SENT');
                            $rootScope.modal.form.to = null;
                            $rootScope.modal.show = false;
                        }
                    }, function(err){
                        $log.error(err);
                    });
                }
            };

            $scope.evalAction = function(type, options){
                $rootScope.flags.loading = true;
                $rootScope.modal.show = false;
                $rootScope.evalArr = [];
                modalType = type;
                modalState = angular.copy(options);
                if(type === 'SEND_REMINDER'){
                    /*
                    * TODO: SMK: SIMILAR FUNCTION EXISTS IN jv.cand.details.evaluations.view.js .. Try to merge them as service or something
                    */
                    candidates.getEvaluationReminderTempl($routeParams.applicationId, modalState.interviewState, function(response){
                        $rootScope.flags.loading = false;
                        $rootScope.modal.title = i18n.SEND_REMINDER;
                        $rootScope.modal.form = response.evaluationFormSendReminderMessage.model.evaluationFormSendReminderMessage;
                        $rootScope.modal.form.hideCC = true;
                        $rootScope.modal.form.to_label = true;
                        $rootScope.modal.form.toObj = angular.copy(response.evaluationFormSendReminderMessage.model.evaluationFormSendReminderMessage.to);

                        angular.forEach(response.evaluationFormSendReminderMessage.model.evaluationFormSendReminderMessage.to, function(value){
                            $rootScope.evalArr.push(value.fullName);
                        });

                        $rootScope.modal.form.to = $rootScope.evalArr.join(', ');
                        $rootScope.modal.show = true;

                        if(modalState.list && modalState.list._PENDING){
                            var evalList=[];
                            angular.forEach(modalState.list._PENDING, function(evaluation){
                                evalList.push(evaluation.evaluationId);
                            });
                            $rootScope.modal.form.entityIdList = evalList;
                        }

                    }, function(){
                        $rootScope.flags.loading = false;
                    });
                }else if(type === 'PRINT'){
                    $scope.evaluations.printPreview = {};
                    $scope.evaluations.printPreview.hasAllInterviewStates = true;
                    window.$windowScope = $scope;
                    window.$windowScope.isPrintEvaluation = true;
                    window.open('details/evaluations/printPreviewEvalPopout.html','_blank','width=1200, height=600, scrollbars=yes');
                    $rootScope.flags.loading = false;
                }else if(type === 'FORWARD'){
                    candidates.getEvalForwardTmpl($routeParams.applicationId, function(response){
                        $rootScope.flags.loading = false;
                        $rootScope.modal.title = i18n.FORWARD_EVALUATION;
                        $rootScope.modal.form = response.forwardEvaluation.model.forwardEvaluationMessage;
                        angular.forEach(response.forwardEvaluation.model.forwardEvaluationMessage.to, function(value){
                            $rootScope.evalArr.push(value.EId);
                        });

                        $rootScope.modal.form.to = $rootScope.evalArr;
                        $rootScope.modal.show = true;
                    }, function(){
                        $rootScope.flags.loading = false;
                    });
                }else{
                    $rootScope.flags.loading = false;
                }
            };

            $scope.viewEvaluation = function(evalId, viewType){
                $rootScope.miniHeader = {
                    show: true,
                    back: 'evaluations/'+$routeParams.applicationId
                };
                if(viewType === 'LIST'){
                    $location.path('evaluations/'+$routeParams.applicationId+'/list/'+evalId);
                }else if(viewType === 'GRID'){
                    $location.path('evaluations/'+$routeParams.applicationId+'/grid/'+evalId);
                }
            };
        }
]);